'use client';

import * as React from 'react';
import { trackPageView } from '@mentimeter/google-tracking';
import { useOnce } from '@mentimeter/react-hooks';
import { useOneTrustReady } from '@mentimeter/onetrust';
import { getVisitorDataCache } from '@mentimeter/visitor/visitor-data';

const ONETRUST_DOMAIN_SCRIPT = process.env.NEXT_PUBLIC_ONETRUST_DOMAIN_SCRIPT;

const TrackingGTM = () => {
  const shouldTrack = true;

  const track = React.useCallback(() => {
    const { preferredLanguage, country } = getVisitorDataCache();
    const { location } = window;

    trackPageView({
      page_location: location.href,
      page_title: document.title,
      country,
      language: preferredLanguage,
      logged_in: false, // it is false for login and signup pages, it is not important for reset_passwords so we hardcode
    });
  }, []);

  useOnce(shouldTrack, () => {
    // backup sending trackPageView in case OneTrust is disabled
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !ONETRUST_DOMAIN_SCRIPT && track();
  });

  // this will trigger when OneTrust is ready and cookie banner is loaded or when cookie categories are changed
  // the reason for that is GTM (and GA) wants us to trigger page view only after we set categories in OneTrust
  // won't trigger if OneTrust is disabled
  // once: false in order to track page view when we change cookie preferences
  useOneTrustReady(track, { once: false });

  return null;
};

export default TrackingGTM;
